import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Carousel from 'react-bootstrap/Carousel';
import FsLightbox from 'fslightbox-react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { useAnimation } from '../../hooks/useAnimation';
import './Certificates.scss';

const Certificates = () => {
  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1
  });
  const { t } = useTranslation();
  const { scaleIn, flipIn, fadeOnly } = useAnimation();

  const certificates = [
    {
      id: 1,
      image: require("../../assets/images/iso.jpg"),
      title: t("certificates.iso.title"),
      description: t("certificates.iso.description"),
    },
    {
      id: 2,
      image: require("../../assets/images/ics.png"),
      title: t("certificates.ics.title"),
      description: t("certificates.ics.description"),
    },
    {
      id: 3,
      image: require("../../assets/images/ocs.png"),
      title: t("certificates.ocs.title"),
      description: t("certificates.ocs.description"),
    },
    // {
    //   id: 4,
    //   image: require("../../assets/images/rcs.jpg"),
    //   title: t("certificates.oeko.title"),
    //   description: t("certificates.oeko.description"),
    // },
    {
      id: 4,
      image: require("../../assets/images/oeko.png"),
      title: t("certificates.oeko.title"),
      description: t("certificates.oeko.description"),
    },
  ];

  return (
    <section id="certificates" className="certificates-section">
      <Container>
        <motion.div
          className="section-header text-center mb-5"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.3 }}
          variants={fadeOnly}
        >
          <h2>{t("certificates.title")}</h2>
          <p>{t("certificates.subtitle")}</p>
        </motion.div>

        <Carousel
          className="certificates-carousel"
          interval={5000}
          touch={true}
        >
          {certificates.map((cert, index) => (
            <Carousel.Item key={cert.id}>
              <Row className="align-items-center">
                <Col md={3}>
                  <motion.div
                    className="certificate-image"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={scaleIn}
                    onClick={() =>
                      setLightboxController({
                        toggler: !lightboxController.toggler,
                        slide: index + 1,
                      })
                    }
                  >
                    <img src={cert.image} alt={cert.title} />
                  </motion.div>
                </Col>
                <Col md={9}>
                  <motion.div
                    className="certificate-content"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={flipIn}
                    transition={{ delay: 0.3 }}
                  >
                    <h3>{cert.title}</h3>
                    <p>{cert.description}</p>
                  </motion.div>
                </Col>
               
              </Row>
            </Carousel.Item>
          ))}
        </Carousel>
      </Container>

      <FsLightbox
        toggler={lightboxController.toggler}
        sources={certificates.map((cert) => cert.image)}
        slide={lightboxController.slide}
      />
    </section>
  );
};

export default Certificates;